import { createTheme } from "@mui/material/styles";

export const getTheme = (mode) =>
  createTheme({
    palette: {
      // mode: "mode", // 👈 important

      primary: {
        // main: mode === "dark" ? "#90caf9" : "#121923",
        main:  "#121923",
      },
      secondary: {
        main: "#027A48",
      },
      error: {
        main: "#ef5350",
      },
      background: {
        // default: mode === "dark" ? "#121212" : "#ffffff",
        // paper: mode === "dark" ? "#1e1e1e" : "#ffffff",
        default:  "#ffffff",
        paper:  "#ffffff",
      },
      text: {
        // primary: mode === "dark" ? "#ffffff" : "#121923",
        primary: "#121923",
      },
    },

    shape: {
      borderRadius: 8,
    },

    typography: {
      button: {
        textTransform: "none",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: "inherit",
            fontSize: "14px",
            fontStyle: "medium",
            fontWeight: 500,
            height: "44px !important",
            letterSpacing: "0.2px",
            boxShadow: "none",
          },
          contained: {
            color: "#fff !important",
            position: "relative",
            overflow: "hidden",
            background: "#0f1729 !important",
            boxShadow: "0 14px 32px -14px rgba(15, 23, 41, 0.5)",
            transition:
              "transform 220ms cubic-bezier(0.22, 1, 0.36, 1), box-shadow 220ms cubic-bezier(0.22, 1, 0.36, 1)",

            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(120deg, transparent 30%, rgba(255,255,255,0.18) 50%, transparent 70%)",
              transform: "translateX(-100%)",
              transition: "transform 700ms cubic-bezier(0.22, 1, 0.36, 1)",
              pointerEvents: "none",
            },
            "&:hover": {
              // background: "#0f1729",
              transform: "translateY(0px)",
              boxShadow: "0 18px 36px -16px rgba(15, 23, 41, 0.55)",

              "&::before": {
                transform: "translateX(100%)",
              },
            },
            "&:disabled": {
              cursor: "not-allowed",
              opacity:0.7
            },
          },
          outlined: {
            border: "1px solid var(--ds-outline)",
            color: "var(--ds-text-primary) !important",
            "&:hover": {
              background: "none",
            },
          },

          text: {
            color: "#000",
            padding: "16px 16px 16px 12px",
            "&:disabled": {
              // boxShadow: "none",
              background: "unset !important",
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            input: {
              fontFamily: "inherit",
              paddingTop: "15px",

              // paddingLeft: "20px",
              "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px white inset",
                WebkitTextFillColor: "var(--Black-Black-500, #6B7280)",
              },
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            height: "44px !important",
            fontFamily: "inherit",
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E5E7EB !important", // Border color on hover
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderWidth: "1px", // Border width on focus
              borderColor: "#E5E7EB !important", // Border color on focus
            },
          },
          notchedOutline: {
            borderWidth: "1px", // Default border width
          },
        },
      },

      MuiButtonBase: {
        styleOverrides: {
          root: {},
        },
      },
    },
  });
